import { render } from "./ShareholderNotificationSettingsTab.vue?vue&type=template&id=ea0eadc6&scoped=true&ts=true"
import script from "./ShareholderNotificationSettingsTab.vue?vue&type=script&lang=ts"
export * from "./ShareholderNotificationSettingsTab.vue?vue&type=script&lang=ts"

import "./ShareholderNotificationSettingsTab.vue?vue&type=style&index=0&id=ea0eadc6&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0eadc6"]])

export default __exports__